import * as React from 'react';
import { useAppSelector } from '../../hooks';
import { EntityContactRole, EntityUserRole, ReportAccessEnum } from '../../redux/ContactSlice';
import { selectedEntity } from '../../redux/EntitySlice';
import { EntityAuthorization, UserRoleEnum, selectUserEntityAuthorizations, selectUserRole } from '../../redux/UserSlice';
import utilityHelper from '../../utils/utilityHelper';


const CanShowGivenAuthorizedContactUserRoles = (props: {
    children: React.ReactNode; entityContactRole: EntityContactRole; entityUserRole: EntityUserRole; reportAccess: ReportAccessEnum | null
}) => {
    const entitySelector = useAppSelector(selectedEntity);
    const authorizedEntitiesSelector: Array<EntityAuthorization> | null = useAppSelector(selectUserEntityAuthorizations);
    const userRoleSelector = useAppSelector(selectUserRole);

    const [canEditEntity, setCanEditEntity] = React.useState<boolean>(false);

    React.useEffect(() => {

        let shouldEnable: boolean = utilityHelper.IsAuthorizedGivenContactRoleUserRoleReportAccess(userRoleSelector, entitySelector,
                                                    authorizedEntitiesSelector, props.entityContactRole, props.entityUserRole, props.reportAccess);

        setCanEditEntity(shouldEnable);

    }, [entitySelector])

    return (

        <React.Fragment>
            {
                canEditEntity == true ?
                    (
                        props.children
                    )

                    : (<></>)
            }
        </React.Fragment>
    );

}

export default CanShowGivenAuthorizedContactUserRoles;